import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';

interface FilePreview {
  title: string;
  show: boolean;
  fileSource?: string;
  onClose: Function;
}
const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 50,
  },
  frameContainer: {
    width: 1024,
    height: 768,
    border: 'none',
  },
});

export default function (props: FilePreview) {
  const classes = useStyles();

  return (
    <Dialog
      onClose={() => props.onClose()}
      open={props.show}
      sx={{ '& .MuiPaper-root': { maxWidth: 'none' } }}
    >
      <Box
        sx={{
          padding: '8px 8px 8px 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <span style={{ fontSize: '1.2rem', fontWeight: 600 }}>
          {props.title}
        </span>
        <IconButton onClick={() => props.onClose()}>
          <CloseIcon />
        </IconButton>
      </Box>
      {props.fileSource ? (
        <iframe
          className={classes.frameContainer}
          title='title'
          src={props.fileSource}
        ></iframe>
      ) : (
        <CircularProgress />
      )}
    </Dialog>
  );
}
